import { render } from "./CompareWorkspace.vue?vue&type=template&id=e4eb80a6&scoped=true"
import script from "./CompareWorkspace.vue?vue&type=script&lang=js"
export * from "./CompareWorkspace.vue?vue&type=script&lang=js"

import "./CompareWorkspace.vue?vue&type=style&index=0&id=e4eb80a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4eb80a6"]])

export default __exports__